<template>
  <div class="row">
    <div class="col-sm-12"><br>
      <div
        class="container-fluid col-md-12"
        style="
          background: rgb(248, 249, 250);
          border-radius: 10px;
          box-shadow: 5px 5px 5px 5px #999999;
        "
        id="contenedor"
      >
      <router-link :to="{ name: 'menu' }">
				<br><h6>Volver</h6>
            </router-link>
     <div class="d-flex justify-content-center">
        
							<div class="row">
								<div class="col">
								<br>
								<img src="https://seguimiento.cmimbral.cl/assets/logo_tienda.png"  width="200" class="img-fluid" alt="Responsive image"><br>
								</div>
							</div>
							
    </div><br>

    <div class="d-flex justify-content-center">
        
							<div class="row">
								<div class="col">
								<h3 class="text-center"><b>Gestión de Stock</b></h3><br>
                </div>
							</div>
							
    </div>
    <!---<div class="d-flex justify-content-center">
      <div class="row">
        <div class="col">
          <select class="form-select" v-model="tipoCarga" @change="cargarProductos()">
            <option value="Productos">Productos</option>
            <option value="Ropa">Ropa</option>
          </select>
        </div>
      </div>
    </div><br>-->
    
    <div class="d-flex justify-content-center">
        
							<div class="row">
								<div class="col">
								<div>
        <table class="table table-striped table-responsive" style="display:block">
           <thead style="background-color:rgb(0,58,140);color:white">
            <tr>
              
              <th>DESCRIPCION</th>
              <th>PRECIO</th>
              <th>STOCK RRHH.</th>
              <th>STOCK TRAN.</th>
              <th>STOCK CAJA.</th>
              <th>ESTADO</th>
              <th>AGREGAR</th>
              <th>AUDITAR</th>
              <th>TRASLADAR</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="x in Productos" :key="x.key">
              <!--<td>{{ x.sku }}</td>-->
              <td>{{ x.descripcion }}</td>
              <td>{{ x.precio }}</td>
              <td>{{ x.stock }}</td>
              <td>{{ x.stockT}}</td>
              <td>{{ x.stockC}}</td>
              <td>{{ x.estado }}</td>
              <td>
                
                <button 
                
                  type="button"
                  
                  class="btn btn-success btn-sm"
                  style="
                    background-color: rgb(0, 56, 143);
                    color: white;
                    border-color: rgb(237, 126, 37);
                  "
                  @click="agregarStock(x.sku,x.key,x.stock,x.stockT,x.stockC)"
                >
                 <i class="fas fa-plus fa-2x"></i>
                </button>
              
              </td>

              <td>
                
                <button 
                
                  type="button"
                  
                  class="btn btn-success btn-sm"
                  style="
                    background-color: rgb(0, 56, 143);
                    color: white;
                    border-color: rgb(237, 126, 37);
                  "
                  @click="verMovimientos(x.sku)"
                >
                 <i class="fas fa-list fa-2x"></i>
                </button>
              
              </td>
              <td>
                
                <button 
                
                  type="button"
                  
                  class="btn btn-success btn-sm"
                  style="
                    background-color: rgb(0, 56, 143);
                    color: white;
                    border-color: rgb(237, 126, 37);
                  "
                  @click="trasladar(x.key,x.sku,x.stock,x.stockT,x.stockC)"
                >
                 <i class="fas fa-edit fa-2x"></i>
                 
                </button>
              
              </td>
              
            </tr>
          </tbody>
        </table></div>
                </div>
							</div>
							
    </div><br>
							

        <br>
       
       
       <!-- <iframe id="pdf" width="100%" height="800px"></iframe>-->
      </div>
    </div>
    <div>

   <b-modal id="modal-1" hide-footer hide-header >
    
    <div class="d-block text-center">
      <h3><b>Agregar Stock</b></h3><br>
      
                <input type="text" id="idDocumentoFb" class="form-control" placeholder="Ingrese RUT facturación" style="display:none"  >
                         
                <div class="row">
                
                    
                    <div class="col">
                        <div class="form-group">
                        <label>CANTIDAD</label>
                        <input type="number" id="cantidad"  class="form-control" placeholder="Ingrese cantidad" style="border-color:rgb(237,126,37)"  required>
                        </div>
                    </div>
                    
                    
                </div><br>
                <div class="row">
                  <div class="col">
                    <label>Sucursal</label>
                    <select class="form-select" aria-label="Default select example" id="sucursal" style="border-color:rgb(237,126,37)">
                        <option value="Centro Comercial">RRHH Centro Comercial </option>
                        <option value="Transportes">Transportes</option>
                        <option value="Caja CC">Caja Centro Comercial</option>
                        </select>
                  </div>
                </div>
                
                <div class="row">
                  <div class="col"><br>
                    <div class="form-group">
                        <label for="observacion">Observación (N° Factura, N° Folios, Rango N° de Vales)</label>
                        <textarea class="form-control" id="observacion" rows="3"  style="border-color:rgb(237,126,37)" required></textarea><br>
                    </div>
                    </div>
                </div>
               <!-- <div class="row" >
                    <div class="col-sm-6">
                        <input style="border-color:rgb(237,126,37)" @change="clickImagen($event)" type="file" accept="image/*" >
                    </div>

                </div>--><br>

                
                <div class="d-flex justify-content-center">
                    <div class="form-group">
                        <button class="btn btn-primary btn-block" @click="agregarStock2()" style="background-color: rgb(0, 56, 143); color: white; border-color: rgb(237, 126, 37);">Agregar</button><br><br>
                    </div>
                </div>

    </div>

  </b-modal>   


  <b-modal id="modal-traslado" hide-footer hide-header >
    
    <div class="d-block text-center">
      <h3><b>Modificar Stock</b></h3><br>
      
                <input type="text" id="idDocumentoFb" class="form-control" placeholder="Ingrese RUT facturación" style="display:none"  >
                         
                <div class="row">
                
                    
                    <div class="col">
                        <div class="form-group">
                        <label>CANTIDAD</label>
                        <input type="number" id="cantidadTraslado" v-model="cantidadTraslado" class="form-control" placeholder="Ingrese cantidad" style="border-color:rgb(237,126,37)"  required>
                        </div>
                    </div>
                    
                    
                </div><br>
                <div class="row">
                  <div class="col">
                    <label>Sucursal salida</label>
                    <select class="form-select" aria-label="Default select example" id="sucursalSalidaTraslado" v-model="sucursalSalidaTraslado" style="border-color:rgb(237,126,37)">
                        <option value="Centro Comercial">RRHH Centro Comercial </option>
                        <option value="Transportes">Transportes</option>
                        <option value="Caja CC">Caja Centro Comercial</option>
                        </select>
                  </div>
                </div>

                <div class="row">
                  <div class="col"><br>
                    <label>Sucursal ingreso</label>
                    <select class="form-select" aria-label="Default select example" id="sucursalIngresoTraslado" v-model="sucursalIngresoTraslado" style="border-color:rgb(237,126,37)">
                        <option value="Centro Comercial">RRHH Centro Comercial </option>
                        <option value="Transportes">Transportes</option>
                        <option value="Caja CC">Caja Centro Comercial</option>
                        </select>
                  </div>
                </div>
                
                <div class="row">
                  <div class="col"><br>
                    <div class="form-group">
                        <label for="observacion">Observación (N° Factura, N° Folios, Rango N° de Vales)</label>
                        <textarea class="form-control" id="observacionTraslado" v-model="observacionTraslado" rows="3"  style="border-color:rgb(237,126,37)" required></textarea><br>
                    </div>
                    </div>
                </div>
               <!-- <div class="row" >
                    <div class="col-sm-6">
                        <input style="border-color:rgb(237,126,37)" @change="clickImagen($event)" type="file" accept="image/*" >
                    </div>

                </div>--><br>

                
                <div class="d-flex justify-content-center">
                    <div class="form-group">
                        <button class="btn btn-primary btn-block" @click="trasladar2()" style="background-color: rgb(0, 56, 143); color: white; border-color: rgb(237, 126, 37);">Trasladar</button><br><br>
                    </div>
                </div>

    </div>

  </b-modal> 


  <b-modal id="modal-2" size="xl" hide-footer hide-header >
    
    <div class="d-block text-center">
      <h3><b>Buscar Movimientos</b></h3><br>
      <div class="row">
        <div class="col-sm-5">
          <input type="text" id="skuAuditar" style="display:none">
								<label ><strong>Fecha desde</strong></label><br>
								<input type="date" v-model="fecha1BF" class="form-control" id="fecha1Auditar" style=" border: solid 1px; border-radius: 5px;border-color:rgb(237,126,37) "/>
								
							</div>
              <div class="col-sm-5">
								<label ><strong>Fecha hasta</strong></label><br>
								<input type="date" v-model="fecha2BF" class="form-control" id="fecha2Auditar" style=" border: solid 1px; border-radius: 5px; border-color:rgb(237,126,37)"/>
              </div>
              <div class="col-sm"><label for="btnBuscarbf" ><strong>Buscar</strong></label><br>
										<button type="submit"   id="btnBuscarbf" class="btn btn-primary" @click="buscarMovimientos2()"  style="background-color:rgb(0,56,143); border-color:rgb(237,126,37)"><i class="fas fa-search"></i></button>
							</div>
      </div>
      <br><br>
      
								
								
      
                         
                <div class="row">
                
                   <div class="col">
                    <table class="table table-striped table-responsive" style="display:block">
           <thead style="background-color:rgb(0,58,140);color:white">
            <tr>
              <th>TIPO</th>
              <th>SUCURSAL</th>
              <th>SKU</th>
              <th>CANTIDAD</th>
              <th>FECHA</th>
              <th>PERSONA</th>
              <th>USUARIO</th>
              <th>OBSERVACIÓN</th>
              
            
              
            </tr>
          </thead>
          <tbody>
            <tr v-for="x in Movimientos" :key="x.key">
              <td>{{ x.tipo }}</td>
              <td>{{ x.sucursal }}</td>
              <td>{{ x.sku }}</td>
              <td>{{ x.cantidad }}</td>
              <td>{{ x.fecha }}</td>
              <td>{{ x.persona }}</td>
              <td>{{ x.usuario }}</td>
              <td>{{ x.observacion }}</td>
             
             
              
             
              
            </tr>
          </tbody>
        </table>
<br><br>
 
                   </div>
              

                

    </div></div>

  </b-modal>
</div>
  </div>
  
</template>

<script>
import { db } from "../firebaseDb";
import Swal from "sweetalert2";
import Vue from 'vue'
    import { BootstrapVue } from 'bootstrap-vue'
    Vue.use(BootstrapVue)
var sd = require('silly-datetime');

export default {
  data() {
    return {
      Productos: [],
      producto:{},
      vendedores:[],
      editado:[],
      chequeEditado:[],
      observacion:'',
      sku:'',
      descripcion:'',
      precio:'',
      stock:'',
      stockProducto:{},
      skuStockProducto:'',
      stockStockProducto:'',
      stockStockProductoT:'',
      stockStockProductoC:'',
      keyStockProducto:'',
      FoliosSap:[],
      FoliosAsignar:[],
      totalFoliosAsignar:0,
      resumenFoliosAsignar:'',
      montoTransferencia:0,
      diferenciaMontos:0,
      idDocumentoFb:'',
      foliosAntiguos:'',
      rutBuscarFolios:'',
      fecha2BF:'',
      fecha1BF:'',
      tipoMonto:'',
      actualizado:{},
      fecha:'',
      hora:'',
      Movimientos:[],
      tipoCarga:'Productos',
      cantidadTraslado:'',
      sucursalIngresoTraslado:'',
      sucursalSalidaTraslado:'',
      skuTraslado:'',
      observacionTraslado:'',

      stockTraslado:'',
      stockTTraslado:'',
      stockCTraslado:'',
      keyTraslado:'',
    };
  },
  created() {
   
            this.usuario=localStorage.nombreUsuario;
            //console.log(this.usuario)
            this.cargarProductos();
            this.validarUsuario();  
            this.obtenerFecha();
    
  },
  methods: {
     cargarProductos(){
      if(this.tipoCarga=="Productos"){
         db.collection('productos').where("convenio","!=",3).orderBy("convenio","asc").orderBy("sku","asc").onSnapshot((snapshotChange) => {
                this.Productos = [];
                if(snapshotChange.empty){
                   Swal.fire({
                      title: "Error",
                      text: "No se encontraron productos",
                      icon: "error",
                    });
                }else{
                    snapshotChange.forEach((doc) => {
                      if(doc.data().sku!="-Seleccione-"){
                        this.Productos.push({
                            key: doc.id,
                            sku: doc.data().sku,
                            descripcion: doc.data().descripcion,
                            precio: doc.data().precio,
                            stock: doc.data().stock, 
                            stockT: doc.data().stockT, 
                            stockC: doc.data().stockC, 
                            estado: doc.data().estado, 
                        })
                    }
                });
                }
               
          })
        }else{
          db.collection('productos').where("convenio","==",3).orderBy("sku","asc").onSnapshot((snapshotChange) => {
                this.Productos = [];
                if(snapshotChange.empty){
                   Swal.fire({
                      title: "Error",
                      text: "No se encontraron productos",
                      icon: "error",
                    });
                }else{
                    snapshotChange.forEach((doc) => {
                      if(doc.data().sku!="-Seleccione-"){
                        this.Productos.push({
                            key: doc.id,
                            sku: doc.data().sku,
                            descripcion: doc.data().descripcion,
                            precio: doc.data().precio,
                            stock: doc.data().stock, 
                            stockT: doc.data().stockT, 
                            stockC: doc.data().stockC, 
                            estado: doc.data().estado, 
                        })
                    }
                });
                }
               
          })
        }
    },
    verMovimientos(sku){
      this.Movimientos=[];
         //console.log(sku)
         //document.getElementById("skuAuditar").value=sku
         this.skuAuditar=sku;
         this.$bvModal.show("modal-2")
        // document.getElementById("sku").value=sku;
    },
    trasladar(key,sku,stock,stockT,stockC){
      this.$bvModal.show("modal-traslado")
      this.skuTraslado=sku
      this.stockTraslado=stock
      this.stockTTraslado=stockT
      this.stockCTraslado=stockC
      this.keyTraslado=key
    },
    trasladar2(){
      db.collection('stock').add({cantidad:this.cantidadTraslado,fecha:this.fecha,hora:this.hora,fr:this.año+this.mes+this.dia,usuario:this.usuario,tipo:"INGRESO",sku:this.skuTraslado,sucursal:this.sucursalIngresoTraslado,observacion:this.observacionTraslado}).then(() => {
                     db.collection('stock').add({cantidad:(this.cantidadTraslado*-1),fecha:this.fecha,hora:this.hora,fr:this.año+this.mes+this.dia,usuario:this.usuario,tipo:"SALIDA",sku:this.skuTraslado,sucursal:this.sucursalSalidaTraslado,observacion:this.observacionTraslado}).then(() => {
                          Swal.fire({
                              title: "Listo",
                              text: "Stock Agregado",
                              icon: "success",
                          })
                          this.actualizarStockTraslado(this.sucursalSalidaTraslado,this.sucursalIngresoTraslado)
                        }).catch((error) => {
                          console.log(error);
                      });



                      /* db.collection('productos').doc(this.keyStockProducto)
                      .update({stock: sum}).then(() => {
                          console.log("Producto actualizado");
                          //this.$router.push('/list')
                      }).catch((error) => {
                          console.log(error);
                      });*/
                    }).catch((error) => {
                      console.log(error);
                   });
    },
    actualizarStockTraslado(sucursalSalida,sucursalIngreso){
      console.log(sucursalSalida,sucursalIngreso)

      //actualizar salida
      if(sucursalSalida=="Caja CC"){
        db.collection('productos').doc(this.keyTraslado)
          .update({stockC:parseInt(this.stockCTraslado)-parseInt(this.cantidadTraslado) }).then(() => {
            console.log("Producto actualizado");
          }).catch((error) => {
            console.log(error);
        });
      }else if(sucursalSalida=="Centro Comercial"){
        db.collection('productos').doc(this.keyTraslado)
          .update({stock:parseInt(this.stockTraslado)-parseInt(this.cantidadTraslado) }).then(() => {
            console.log("Producto actualizado");
          }).catch((error) => {
            console.log(error);
        });
      }else{
        db.collection('productos').doc(this.keyTraslado)
          .update({stockT:parseInt(this.stockTTraslado)-parseInt(this.cantidadTraslado) }).then(() => {
            console.log("Producto actualizado");
          }).catch((error) => {
            console.log(error);
        });
      }

      //actualizar ingreso


      if(sucursalIngreso=="Caja CC"){
        db.collection('productos').doc(this.keyTraslado)
          .update({stockC:parseInt(this.stockCTraslado)+parseInt(this.cantidadTraslado) }).then(() => {
            console.log("Producto actualizado");
            this.$bvModal.hide("modal-traslado")
          }).catch((error) => {
            console.log(error);
        });
      }else if(sucursalIngreso=="Centro Comercial"){
        db.collection('productos').doc(this.keyTraslado)
          .update({stock:parseInt(this.stockTraslado)+parseInt(this.cantidadTraslado) }).then(() => {
            console.log("Producto actualizado");
            this.$bvModal.hide("modal-traslado")
          }).catch((error) => {
            console.log(error);
        });
      }else{
        db.collection('productos').doc(this.keyTraslado)
          .update({stockT:parseInt(this.stockTTraslado)+parseInt(this.cantidadTraslado) }).then(() => {
            console.log("Producto actualizado");
            this.$bvModal.hide("modal-traslado")
          }).catch((error) => {
            console.log(error);
        });
      }
     
    },
    buscarMovimientos2(){
      var sku=this.skuAuditar
      var fecha1=document.getElementById("fecha1Auditar").value
      var fecha2=document.getElementById("fecha2Auditar").value
      var fecha11=fecha1.replaceAll("-","")
      var fecha22=fecha2.replaceAll("-","")
     // console.log(sku,fecha11,fecha22)
      db.collection('stock').where("fr",">=",fecha11).where("fr","<=",fecha22).where("sku","==",sku).orderBy("fr","desc").orderBy("hora","desc").onSnapshot((snapshotChange) => {
                this.Movimientos = [];
                if(snapshotChange.empty){
                   Swal.fire({
                      title: "Error",
                      text: "No se encontraron movimientos",
                      icon: "error",
                    });
                }else{
                    snapshotChange.forEach((doc) => {
                      if(doc.data().sku!="-Seleccione-"){
                        this.Movimientos.push({
                            key: doc.id,
                            sku: doc.data().sku,
                            cantidad: doc.data().cantidad,
                            tipo: doc.data().tipo,
                            usuario: doc.data().usuario, 
                            fecha: doc.data().fecha+" "+doc.data().hora,
                            persona:(doc.data().persona?doc.data().persona:"NO"),  
                            sucursal:doc.data().sucursal,
                            observacion:doc.data().observacion
                        })
                    }
                });
                }
               
          })
    },


    agregarStock(sku,key,stock,stockT,stockC){
         //console.log(key)
         this.$bvModal.show("modal-1")
         this.skuStockProducto=sku;
         this.keyStockProducto=key;
         this.stockStockProducto=stock;
         this.stockStockProductoT=stockT;
         this.stockStockProductoC=stockC;
        // document.getElementById("sku").value=sku;
    },
    agregarStock2() {
      if(document.getElementById("cantidad").value!=""){

        if(document.getElementById("observacion").value!=""){
                    this.stockProducto.sku = this.skuStockProducto//document.getElementById("sku").value.toUpperCase() 
                    this.stockProducto.cantidad = document.getElementById("cantidad").value
                    this.stockProducto.observacion = document.getElementById("observacion").value
                    this.stockProducto.sucursal=document.getElementById("sucursal").value
                    this.stockProducto.fr = this.año+this.mes+this.dia
                    this.stockProducto.usuario=this.usuario;
                    this.stockProducto.fecha=this.fecha;
                    this.stockProducto.hora=this.hora;
                    this.stockProducto.tipo="INGRESO"
                    if(document.getElementById("sucursal").value=="Centro Comercial"){
                      var sum=parseInt(this.stockStockProducto)+parseInt(document.getElementById("cantidad").value)
                      //this.actualizado.stock=sum;
                      db.collection('stock').add(this.stockProducto).then(() => {
                          Swal.fire({
                          title: "Listo",
                          text: "Stock Agregado",
                          icon: "success",
                      })
                      db.collection('productos').doc(this.keyStockProducto)
                      .update({stock: sum}).then(() => {
                          console.log("Producto actualizado");
                          //this.$router.push('/list')
                      }).catch((error) => {
                          console.log(error);
                      });
                    // document.getElementById("sku").value=""
                      document.getElementById("cantidad").value=""
                      document.getElementById("observacion").value=""
                      //this.imagenCorreo(correo,id,usuario,vendedor,rutFacturacion,cuenta,nombre,monto,fechaTransaccion);
                      this.$bvModal.hide("modal-1")
                    }).catch((error) => {
                        console.log(error);
                    });

                    }else if(document.getElementById("sucursal").value=="Transportes"){
                      var sum2=parseInt(this.stockStockProductoT)+parseInt(document.getElementById("cantidad").value)
                      //this.actualizado.stock=sum2;
                      db.collection('stock').add(this.stockProducto).then(() => {
                          Swal.fire({
                          title: "Listo",
                          text: "Stock Agregado",
                          icon: "success",
                      })
                      db.collection('productos').doc(this.keyStockProducto)
                      .update({stockT: sum2}).then(() => {
                          console.log("Producto actualizado");
                          //this.$router.push('/list')
                      }).catch((error) => {
                          console.log(error);
                      });
                    // document.getElementById("sku").value=""
                      document.getElementById("cantidad").value=""
                      document.getElementById("observacion").value=""
                      //this.imagenCorreo(correo,id,usuario,vendedor,rutFacturacion,cuenta,nombre,monto,fechaTransaccion);
                      this.$bvModal.hide("modal-1")
                      }).catch((error) => {
                          console.log(error);
                      });

                      
                    }else{
                      var sum3=parseInt(this.stockStockProductoC)+parseInt(document.getElementById("cantidad").value)
                      //this.actualizado.stock=sum2;
                      db.collection('stock').add(this.stockProducto).then(() => {
                          Swal.fire({
                          title: "Listo",
                          text: "Stock Agregado",
                          icon: "success",
                      })
                      db.collection('productos').doc(this.keyStockProducto)
                      .update({stockC: sum3}).then(() => {
                          console.log("Producto actualizado");
                          //this.$router.push('/list')
                      }).catch((error) => {
                          console.log(error);
                      });
                    //document.getElementById("sku").value=""
                      document.getElementById("cantidad").value=""
                      document.getElementById("observacion").value=""
                      //this.imagenCorreo(correo,id,usuario,vendedor,rutFacturacion,cuenta,nombre,monto,fechaTransaccion);
                      this.$bvModal.hide("modal-1")
                      }).catch((error) => {
                          console.log(error);
                      });
  

                    }


                  }else{
            Swal.fire({
                        title: "Error",
                        text: "Debe ingresar el n° de factura",
                        icon: "error",
                    })
      }     
      }else{
            Swal.fire({
                        title: "Error",
                        text: "Debe ingresar una cantidad",
                        icon: "error",
                    })
      }
                    



                    /*this.producto.fecha=this.fecha;
                    this.producto.hora=this.hora;
                    this.producto.estado='pendiente';*/
                   
                
                

            },


     validarUsuario(){
             //document.getElementById("monto").display = "none";   
            if(this.usuario==undefined || this.usuario=="X"){
                this.$router.push('/')
            }
        },

      leer(){
                var rut = document.getElementById("rut").value;
				var rutx=rut.replace("-","");
				var largo=rutx.length
				//console.log(largo,largo-1)
				var rut2=rutx.slice(0,largo-1)
				var rut3=rutx.slice(largo-1)
                //console.log(rut2+"-"+rut3)
				document.getElementById("rut").value=(rut2+"-"+rut3)
				
        },
      
      obtenerFecha(){
            this.fecha=sd.format(new Date(), 'DD-MM-YYYY');
            this.dia=(sd.format(new Date(), 'DD'))
            this.mes=(sd.format(new Date(), 'MM'))
            this.año=(sd.format(new Date(), 'YYYY'))
            this.hora=sd.format(new Date(), 'HH:mm');
        },

     
    
  },
};
</script>

<style>
.btn-primary {
  margin-right: 12px;
}
</style>